import axios from 'axios';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { OrderItemsDetail } from './OrderItemsDetail';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const COLLECTION = 'public_store_orders';
const money = (v) => `$ ${(Number(v) || 0).toFixed(2)}`;

export const PublicStoreOrders = ({ orders, onRefresh }) => {
  const setStatus = async (id, status) => {
    try {
      await axios.put(`${API}/public/store/orders/${id}`, { status }, { withCredentials: true });
      toast.success('Status atualizado');
      onRefresh();
    } catch (e) { toast.error(e.response?.data?.detail || 'Erro ao atualizar status'); }
  };
  const settle = async (id, phase) => {
    try {
      await axios.post(`${API}/admin/order-settle`, { collection: COLLECTION, order_id: id, phase }, { withCredentials: true });
      toast.success('Pagamento registrado');
      onRefresh();
    } catch (e) { toast.error(e.response?.data?.detail || 'Erro ao registrar pagamento'); }
  };
  const copyLink = (id) => {
    navigator.clipboard?.writeText(`${window.location.origin}/pedido/${COLLECTION}/${id}`)?.catch(() => {});
    toast.success('Link do saldo copiado!');
  };

  return (
    <div className="bg-white border border-[#E6E2D8] rounded-lg overflow-hidden mt-8" data-testid="public-store-orders">
      <div className="px-5 py-4 border-b border-[#E6E2D8]">
        <h3 className="font-['Outfit'] font-semibold text-lg text-[#1A1A1A]">Pedidos da Loja Online</h3>
        <p className="text-xs text-[#73706A]">Compras feitas pelo link público /loja (com tamanho e cor de cada peça).</p>
      </div>
      {orders.length === 0 ? (
        <p className="p-8 text-center text-[#73706A]">Nenhum pedido da loja online</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="bg-[#F5F2EB]">
                <th className="table-header">Cliente</th>
                <th className="table-header">Itens (tamanho / cor)</th>
                <th className="table-header">Total</th>
                <th className="table-header">Data</th>
                <th className="table-header">Pagamento</th>
                <th className="table-header text-right">Entrega</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((o, i) => (
                <tr key={o.id} className="align-top hover:bg-[#F5F2EB]/50 transition-colors" data-testid={`public-order-row-${i}`}>
                  <td className="table-cell">
                    <p className="font-medium text-[#1A1A1A]">{o.name}</p>
                    <p className="text-[11px] text-[#73706A]">{o.phone}</p>
                    <p className="text-[11px] text-[#73706A] break-all">{o.email}</p>
                  </td>
                  <td className="table-cell">
                    {o.items?.length ? <OrderItemsDetail items={o.items} testid={`public-order-items-${i}`} />
                      : <span className="text-xs">{o.product_name} x{o.quantity} {o.size && `— Tam ${o.size}`} {o.color && `· Cor ${o.color}`}</span>}
                  </td>
                  <td className="table-cell font-medium text-[#2D6A4F]">{money(o.amount)}</td>
                  <td className="table-cell text-[#73706A]">{new Date(o.created_at).toLocaleDateString('pt-BR')}</td>
                  <td className="table-cell">
                    <span className={`badge ${o.payment_status === 'pago' ? 'badge-success' : o.payment_status === 'parcial' ? 'badge-info' : 'badge-warning'}`}>{o.payment_status || 'pendente'}</span>
                    {o.payment_mode === 'deposit' && (
                      <div className="mt-1 text-[11px] text-[#73706A]">
                        <div>Sinal {money(o.deposit_amount)}: {o.deposit_status}</div>
                        <div>Saldo {money(o.balance_amount)}: {o.balance_status}</div>
                      </div>
                    )}
                  </td>
                  <td className="table-cell text-right">
                    <div className="flex flex-col items-end gap-1">
                      <Select value={o.status || 'pendente'} onValueChange={(v) => setStatus(o.id, v)}>
                        <SelectTrigger className="w-28" data-testid={`public-order-status-${i}`}><SelectValue /></SelectTrigger>
                        <SelectContent>
                          <SelectItem value="pendente">Pendente</SelectItem>
                          <SelectItem value="preparando">Preparando</SelectItem>
                          <SelectItem value="entregue">Entregue</SelectItem>
                          <SelectItem value="cancelado">Cancelado</SelectItem>
                        </SelectContent>
                      </Select>
                      {o.payment_status !== 'pago' && (
                        <div className="flex gap-1 flex-wrap justify-end">
                          {o.payment_mode === 'deposit' ? (<>
                            {o.deposit_status !== 'pago' && <Button variant="outline" size="sm" className="h-7 text-[11px]" onClick={() => settle(o.id, 'deposit')} data-testid={`public-order-deposit-${i}`}>Sinal pago</Button>}
                            {o.balance_status !== 'pago' && <Button variant="outline" size="sm" className="h-7 text-[11px]" onClick={() => settle(o.id, 'balance')} data-testid={`public-order-balance-${i}`}>Saldo pago</Button>}
                            <Button variant="outline" size="sm" className="h-7 text-[11px] text-[#0077B6]" onClick={() => copyLink(o.id)} data-testid={`public-order-link-${i}`}>Link saldo</Button>
                          </>) : (
                            <Button variant="outline" size="sm" className="h-7 text-[11px]" onClick={() => settle(o.id, 'full')} data-testid={`public-order-paid-${i}`}>Marcar pago</Button>
                          )}
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
